<script>
import { format } from 'date-fns'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            dateStr: ''
        }
    },
    computed: {
        ...mapGetters({
            currentPage: 'getCurrentPage'
        })
    },
    mounted () {
        this.dateStr = new Date()
    },
    methods: {
        format
    }
}
</script>
<template>
    <footer>
        <div class="footer-container">
            <div class="logo">
                <img src="../assets/images/doe-logo.png" alt="doe logo">
            </div>
            <div class="about-us">
                <h4>About Us</h4>
                <p>The Growth Explorer Team is a small team with a mission to make data more accessible. Our overall goal is to help educators make better and easier decisions to support our schools and students.</p>
            </div>
            <div class="feedback">
                <div>
                    <a href="mailto:growthexplorer@schools.nyc.gov"><span>Share Your Feedback</span> <i class="fas fa-envelope"></i></a>
                </div>
            </div>    
            <div class="update">
                <p>Last updated at 12:01am on {{ format(dateStr, "MMMM DD, YYYY") }}</p>
            </div>
        </div>
    </footer>
</template>
<style lang="scss" scoped>
    footer {
        border-top: 1px solid #ced3dc;
        width: 100%;
        padding: 16px 15px 16px 15px;
        a span {
            display: inline-block;
            margin-right: 5px;
        }
    }
    .logo {
        width: 200px;
        img {
            width: 100%
        }
    } 
    .about-us, .update {
        display: none;
    }
    .feedback {
        a {
            font-size: .75em;
            color: #2c557d;
            text-decoration: none;
        }
    }
    @media all and (min-width: 730px) {
        .footer-container {
            display: flex;
            justify-content: space-between;
            h4, p, a {
                font-family: Arial;
            }
        }
        .about-us, .update {
            display: block;
        }
        .about-us {
            width: 400px;
            h4 {
                color: #d97d00;
                margin: 0;
            }
        }
        .feedback, .update {
            display: flex;
            align-items: center;
            div {
                padding: .5em 2em;
                border-left: 1px solid #333333;
                border-right: 1px solid #333333;
            }
        }
    }
</style>